<template>
  <CustomeTable />
</template>

<script>
import CustomeTable from "@/view/content/table/CustomeTable.vue";
export default {
  components: {
    CustomeTable,
  },
};
</script>

<style>
</style>